import { ssoApi } from "@sso/apis";
import { ApiMethodKeys, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { getUserFromSession, logInUser } from "@sso/store/slices/auth";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { GetSessionResponse, LoginResponse, SignInType } from "@sso/types";

import { Endpoints } from "../endpoints";

export const loginApi = ssoApi.injectEndpoints({
  endpoints: builder => ({
    signIn: builder.mutation<LoginResponse, SignInType>({
      query: data => ({ url: Endpoints.LOGIN, method: ApiMethodKeys.POST, data }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(({ data }) => {
          dispatch(logInUser(data));
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.LOGIN }));
        });
      },
    }),
    getSession: builder.mutation<GetSessionResponse, void>({
      query: () => ({ url: `${Endpoints.LOGIN}/AuthUser`, method: ApiMethodKeys.OPTIONS }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(({ data }) => {
          dispatch(getUserFromSession(data));
        });
      },
    }),
  }),
});

export const { useSignInMutation, useGetSessionMutation } = loginApi;
